import { useQuery } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi, WorkspaceMemberData } from 'api/client'

interface Props {
  workspaceKey?: string
}

export const useWorkspaceUsers = ({ workspaceKey }: Props) => {
  return useQuery<WorkspaceMemberData>(
    ['workspaces', workspaceKey, 'users'],
    async () => {
      const res = await sendToApi<WorkspaceMemberData>(`/w/${workspaceKey}/members`)

      if (res.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error()
      }
      return res.data
    },
    {
      refetchOnWindowFocus: false,
      enabled: !!workspaceKey,
    },
  )
}
